import { Component, Input, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { environment } from '../../../../environments/environment';
import { FilenamePipe } from '../../../pipes/filename.pipe';
import { ComponentService } from '../../../services/component.service';
import { NgForm } from '@angular/forms';
import { Subscription } from 'rxjs';
import { tap, filter, debounceTime } from 'rxjs/operators';
import { FontsService, Font } from '../../../services/fonts.service';
import { OverlayService } from '../../../services/overlay.service';

@Component({
	selector: 'app-personalized-image',
	templateUrl: './personalized-image.component.html',
	styleUrls: ['./personalized-image.component.scss']
})
export class PersonalizedImageComponent implements OnInit, OnDestroy {
	@Input() componentData: any;
	@Input() formHeight: string;
	@Input() pageType: string;
	@Input() componentID: number;
	@Input() urlGlobalRegExp: any;
	@ViewChild('personalizedImageForm', { static: true }) personalizedImageForm: NgForm;
	@ViewChild('nameField', { static: true }) nameField;
	personalizedImageFormSubscription: Subscription;
	font;
	multiFontList = [];
	isModalShown = false;
	modalHeight = window.innerHeight * 0.8;
	apiUrl = environment.apiURL;
	multiTagVersion = false;
	fontStyle;
	fonts: Array<Font>;

	constructor(
		private comService: ComponentService,
		private sanitation: DomSanitizer,
		private fontsService: FontsService,
		private filenamePipe: FilenamePipe,
		private overlay: OverlayService
	) {}

	ngOnInit() {
		this.multiTagVersion = this.componentData.config.version > 1 && this.componentData.config.merge_array.length != 0;

		this.personalizedImageFormSubscription = this.personalizedImageForm.valueChanges
			.pipe(
				tap(() =>
					this.comService.updateDisabledSave(
						(this.personalizedImageForm.dirty && this.personalizedImageForm.invalid) || this.nameField.editComponentName
					)
				),
				filter((form) => this.personalizedImageForm.dirty && this.personalizedImageForm.valid),
				debounceTime(2000)
			)
			.subscribe();

		this.fonts = this.fontsService.getFonts();

		if (!this.multiTagVersion) {
			this.font =
				this.fontsService.getFontsArray().indexOf(this.componentData.config.text.font) === -1
					? 'Custom Font'
					: this.componentData.config.text.font;
			this.componentData.config.text.strikethrough = this.componentData.config.text.strikethrough
				? this.componentData.config.text.strikethrough
				: false;
			this.componentData.config.text.transform = this.componentData.config.text.transform
				? this.componentData.config.text.transform
				: 'none';
		} else {
			for (const key in this.componentData.config.merge_array) {
				if (this.componentData.config.merge_array.hasOwnProperty(key)) {
					this.multiFontList[key] =
						this.fontsService.getFontsArray().indexOf(this.componentData.config.merge_array[key].text.font) === -1
							? 'Custom Font'
							: this.componentData.config.merge_array[key].text.font;
					this.componentData.config.merge_array[key].text.strikethrough = this.componentData.config.merge_array[key].text
						.strikethrough
						? this.componentData.config.merge_array[key].text.strikethrough
						: false;
					this.componentData.config.merge_array[key].text.transform = this.componentData.config.merge_array[key].text.transform
						? this.componentData.config.merge_array[key].text.transform
						: 'none';
				}
			}
		}

		this.changeFont();
	}

	ngOnDestroy() {
		this.personalizedImageFormSubscription.unsubscribe();
	}

	brodcastToPreview() {
		this.comService.updateComponentData(this.componentData);
		this.comService.updatePreviewData();
	}

	openPersonalizedImagePopup() {
		this.componentData.config.fullScreenCapture = this.sanitation.bypassSecurityTrustStyle(
			'url(' + this.componentData.config.source + ') 0 0 no-repeat'
		);
	}

	processReturnedData(event) {
		this.isModalShown = false;
		if (event.method === 'update') {
			this.componentData = event.data;
		}
	}

	changeFont(): void {
		let fontStyles = '';
		if (this.multiTagVersion) {
			this.componentData.config.merge_array.forEach((item) => {
				const fontName = this.filenamePipe.transform(item.text.font);
				fontStyles =
					`${fontStyles}
        @font-face {
          font-family: '${fontName.substr(0, fontName.length - 4)}';
          src: url('` +
					item.text.font +
					`');
        `;
			});
		} else {
			const fontName = this.filenamePipe.transform(this.componentData.config.text.font);
			this.componentData.fontName = this.sanitation.bypassSecurityTrustStyle(`'` + fontName.substr(0, fontName.length - 4) + `'`);
			fontStyles = `@font-face {
                        font-family: 'personalimageFont';
                        src: url('${this.componentData.config.text.font}');
                      }`;
		}
		const css = `<style> ${fontStyles} </style>`;
		const container = document.getElementById('personalimageFontStyleContainer');
		const style = document.createElement('style');
		style.appendChild(document.createTextNode(css));
		container.innerHTML = css;
	}

	removeTag(index) {
		this.componentData.config.merge_array.splice(index, 1);
		this.componentData.config.merge_array.forEach((item, index) => {
			item.tag_name = index == 0 ? 'tag' : `tag${index + 1}`;
		});
	}

	addText() {
		let defaultFont = this.fonts.find((font) => font.label === 'Arial');
		if (this.componentData.config.merge_array.length < 5) {
			const defaultEntry = {
				text_cut_method: 'default',
				merge_tag: '',
				tag_name: `tag${this.componentData.config.merge_array.length + 1}`,
				default_text: '',
				item_width: 150,
				item_height: 30,
				rotate: 0,
				parser: {
					left_offset: 0,
					top_offset: 0
				},
				text: {
					font: defaultFont.url,
					'font-size': 20,
					color: '#000000',
					text_alignment: 'left'
				}
			};
			this.componentData.config.merge_array.push(defaultEntry);
		} else {
			this.overlay.updateOverlay(true, 'You have reached the limit of 5 text placements.', 'alert');
		}
	}

	changeHeightSize(index) {
		this.componentData.config.merge_array[index].item_height = Math.floor(
			this.componentData.config.merge_array[index].text['font-size'] * 1.7
		);
	}
}
